import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0); // Vai para o topo
  }, [pathname]); // Sempre que a rota mudar

  return null;
};

export default ScrollToTop;
